module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEZSURBVHgBnZPLccIwEIZXcuzxkXSQVJB0kKSCkAoSX/w4JakgdBDf/LgYKmCoAOiADnAJvvpgm3/BMBqPYAT/jGZlafdb7UoWBCVJ8kCKXNetPM+ryEB3HCyl3KqLdV0vYMYmAMnZhotCiBcylOyPOoSMhmWdBfQZN5pTPBnEHwBN06zpRu0B6EOsZJ62bfsYhuHCBCCOkzzPl13XvXJwFEUlGUoeJyjDg6ksy5rTFRLqR5ZlPzD/GHEQBL/qHm7lC++lQoml7/sbLYCVpmkMp28Vonts8FnZtv0hdMdSICV68gY7AeBz6Mf90gL6rBz0RxfEAHluEzcxYQeM2QUGCTIQ9wAlvWM6hn2GHfG64zj3dIuKojj9KztZFmEFDUv6YAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 1